module.exports = __webpack_public_path__ + "img/close-primary.55f86639.svg";